module.exports = __webpack_public_path__ + "assets/face_test.cb9350dd.svg";